import { ClyCoreConfig } from '@coinlocally/cly-core';
import { useCloseModal } from '@coinlocally/cly-core/hooks';
import { FC } from 'react';
import { SimpleModal } from './simple-modal';
import { IChangeLanguagePropTypes } from './types';
import styles from './change-language.module.css';
import { useTranslation } from 'react-i18next';

export const ChangeLanguageModal: FC<IChangeLanguagePropTypes> = ({ status, className, setStatus, onLanguageClick }) => {
	const [_status, onClose] = useCloseModal({ status, setStatus });
	const language = ClyCoreConfig.LANGUAGE;
	const { t } = useTranslation('components', { keyPrefix: 'modals' });
	const languages: [string, TLang][] = [
		['English', 'en'],
		['русский', 'ru'],
		['فارسی', 'fa'],
		['deutsch', 'de'],
		['español', 'es'],
		['Français', 'fr'],
	];

	const onLanguageClickHandler = (lng: TLang) => {
		if (lng !== language) {
			onLanguageClick(lng);
			onClose();
		}
	};
	return (
		<div className={`${styles.container} ${className ?? ''}`}>
			<SimpleModal maxWidth={486} title={t('choose-your-language')} onClose={onClose} status={_status}>
				<div className={styles.body}>
					{languages.map((item, index) => (
						<div
							key={`language_item_${index}`}
							style={{ fontFamily: item[1] === 'fa' ? 'YekanBakh' : 'unset' }}
							className={`${styles.language} ${item[1] === language ? styles.active : ''}`}
							onClick={() => {
								onLanguageClickHandler(item[1]);
							}}
						>
							{item[0]}
						</div>
					))}
				</div>
			</SimpleModal>
			;
		</div>
	);
};
